import { AbilityBuilder, PureAbility } from '@casl/ability';
import Region from '../../../../constants/region';

function ScheduleItems(user) {
    const { can, cannot, rules } = new AbilityBuilder(PureAbility);
    const {
        role,
        data: { region, subuser },
    } = user;

    can('search_by_route', 'schedule_item');

    if (role === 'admin') {
        can('mutate', 'schedule_item');
        can('upload', 'raw_milk_csv');
        can('upload', 'processed_fluid_csv');
        if (region === Region.UDA) {
            // Only UDA admins have the ability to refresh fairlife numbers
            can('refresh', 'fairlife_number');
        }
    }
    if (role === 'transport') {
        if (region === Region.CDI) can('upload', 'raw_milk_csv');
    }
    if (subuser && region === Region.CDI && role === 'processor') {
        cannot('search_by_route', 'schedule_item');
    }

    return rules;
}

export default ScheduleItems;
